export default __webpack_public_path__ + "static/media/upload-icon.779c691d.png";